<template>
  <div class="contacts-uploader">
    <!-- File upload modal -->
    <modal
      :title="modalTitle"
      :open="open"
      :saveText="modalSaveText"
      @save="fileUpload"
      @cancel="cancel"
    >
      <div class="contacts-uploader-dropbox">
        <p>{{ $t("ui.contacts.import.description") }}</p>
        <p>{{ $t("ui.contacts.import.format") }}</p>
        <div class="xls-upload">
          <upload-field @change="fileChange" />
        </div>
        <div class="errors" v-if="error">
          <span class="errors-icon">
            <q-icon name="error_outline" />
          </span>
          <span class="errors-msg">{{ error }}</span>
        </div>
      </div>
    </modal>

    <!-- Loader displayed while uploading/processing -->
    <div class="contacts-uploader-loader" v-if="uploading">
      <loading></loading>
    </div>

    <!-- Upload report -->
    <modal
      :title="$t('ui.contacts.import.success_modal_title')"
      :open="importReportOpen"
      cancelText=""
      saveText="ui.global.ok"
      @save="importReportClose()"
      @cancel="importReportClose()"
    >
      <p>{{ $t('ui.contacts.import.success_modal_body') }}</p>
      <p>{{ $t('ui.contacts.import.success_modal_report', {
          total: importReport.created_contacts + importReport.updated_contacts,
          new: importReport.created_contacts,
          updated: importReport.updated_contacts
        }) }}</p>
    </modal>
  </div>
</template>

<script>
import UploadField from "@/components/helpers/DataInput/UploadField";
import ContactsApi from "@/api/Contacts";
import { EventBus } from "@/EventBus.js";
import Modal from "@/components/helpers/Layout/NewModal";
import Loading from '@/components/helpers/Specific/Loading.vue'

export default {
  name: "UploadContacts",
  components: {
    UploadField,
    Modal,
    Loading,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contactsApi: new ContactsApi(),
      open: false,
      uploading: false,
      file: null,
      error: "",
      importReportOpen: false,
      importReport: {},
    };
  },
  computed: {
    modalSaveText() {
      return this.$t("ui.button.users.upload_xls");
    },
    modalTitle() {
      return this.$t("ui.contacts.import.title");
    }
  },
  beforeMount() {
    this.open = this.isOpen
  },
  mounted() {
    EventBus.$on("action", this.handleAction);
  },
  methods: {
    fileChange(payload) {
      this.file = payload;
      this.error = "";
    },
    fileUpload() {
      let formData = new FormData()
      formData.append("file", this.file)
      this.uploading = true
      this.$emit("contactUploadStarted")
      this.contactsApi
        .import(formData, this.$i18n.locale)
        .then(response => {
          this.$store.commit("SET_NOTIFICATION", {
            title: "ui.contacts.import.success_flash",
            type: "success"
          });
          EventBus.$emit("action", "user_invited");
          this.$emit("contactUploadComplete", response);
          this.importReport = response
          this.importReportOpen = true
        })
        .catch(e => {
          this.error = this.$t("errors.users.xls_import.wrong_file");
        })
        .finally(() => {
          this.uploading = false
        })
    },
    handleAction(action) {
      if (action == "users.invite_xls") {
        this.error = ''
        this.open = true;
      }
    },
    cancel() {
      this.$emit("contactUploadCancelled")
      this.open = false;
      this.error = ''
    },
    importReportClose() {
      this.importReportOpen = false
      this.importReport = {}
    },
  },
  watch: {
    isOpen() {
      this.open = this.isOpen;
    }
  }
}
</script>

<style lang="sass">
.contacts-uploader
  .modal
    z-index: 100

  .contacts-uploader-dropbox
    p
      color: $ink-light

    .actions
      text-align: right
      display: block

    .errors
      display: flex
      flex-direction: row
      align-items: center
      position: relative
      text-align: left
      padding: 13px 0
      background-color: $red-lighter
      border-radius: 4px
      min-height: 56px
      color: $ink
      font-size: 14px
      font-weight: $font-medium
      .errors-icon
        display: inline-block
        position: absolute
        left: 20px
        padding: 3px
        background-color: white
        color: $red
        border-radius: 50%
        i.q-icon
          font-size: 24px
      .errors-msg
        display: inline-block
        padding-left: 70px

  .contacts-uploader-loader
    z-index: 200
    position: absolute
    top: 0
    left: 0
    margin: 0 auto
    width: 100%
    height: 100%
    background-color: rgba(0, 0, 0, 0.1)
    .spinner
      div
        background-color: rgba(0, 0, 0, 0.5)
</style>



// WEBPACK FOOTER //
// UploadContacts.vue?5812c7e5